import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  CreateUserProgramInstituteRequestObjectSchema,
  CreateUserProgramInstituteRequestObjectType,
  CreateUserProgramInstituteResponseSchema,
  CreateUserProgramInstituteResponseType
} from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseCreateUserProgramInstituteApiInterface {
  createUserProgramInstituteApi: UseMutateAsyncFunction<
    CreateUserProgramInstituteResponseType,
    Error,
    CreateUserProgramInstituteRequestObjectType
  >;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: MutationStatus;
  reset: () => void;
}

const useCreateUserProgramInstituteApi =
  (): UseCreateUserProgramInstituteApiInterface => {
    const { paymentServices } = usePaymentServices();

    const createUserProgramInstitute = (
      requestObject: CreateUserProgramInstituteRequestObjectType
    ) => {
      try {
        CreateUserProgramInstituteRequestObjectSchema.parse(requestObject);
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return paymentServices
        .createUserProgramInstitute(requestObject)
        .then((response) => {
          try {
            CreateUserProgramInstituteResponseSchema.parse(response ?? {});
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return response;
        });
    };

    const { mutateAsync, isLoading, isError, error, status, reset } =
      useMutation(createUserProgramInstitute, {
        mutationKey: ['createUserProgramInstituteApi']
      });

    return {
      createUserProgramInstituteApi: mutateAsync,
      isLoading,
      isError,
      error: error ? getAPIErrorMessage(error) : null,
      status,
      reset
    };
  };

export { useCreateUserProgramInstituteApi };
